import apiClient from './client';

export async function sendDesktopLink(email, page) {
  const res = await apiClient.post('/api/leads/send-desktop-link', {
    email,
    source: 'mobile-banner',
    page,
  });
  return res.data;
}
